module.exports = __webpack_public_path__ + "img/shop.7be52520.svg";